import { readEnrollmentDraftSnapshot, readEnrollmentDraftValue } from './enrollmentDraftData'

export type EnrollmentDraftRecord = Record<string, string>

type EnrollmentDraftLike = Partial<{
  firstName: string
  lastName: string
  middleName: string
  email: string
  phone: string
  phoneNumber: string
  address: string
  addressLine1: string
  city: string
  state: string
  zipCode: string
  locationExternalId: string
  programExternalId: string
}>

const withFallback = (value: string, fallback?: string) => value || fallback || ''

export function getEnrollmentDraftRecord(): EnrollmentDraftRecord {
  return readEnrollmentDraftSnapshot() as EnrollmentDraftRecord
}

export function getEnrollmentDraftFirstName(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('firstName'), fallback)
}

export function getEnrollmentDraftLastName(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('lastName'), fallback)
}

export function getEnrollmentDraftMiddleName(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('middleName'), fallback)
}

export function getEnrollmentDraftEmail(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('email'), fallback)
}

export function getEnrollmentDraftPhoneNumber(fallback?: string) {
  return withFallback(
    readEnrollmentDraftValue('phoneNumber') || readEnrollmentDraftValue('phone'),
    fallback
  )
}

export function getEnrollmentDraftAddress(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('address'), fallback)
}

export function getEnrollmentDraftAddressLine1(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('addressLine1'), fallback)
}

export function getEnrollmentDraftCity(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('city'), fallback)
}

export function getEnrollmentDraftState(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('state'), fallback)
}

export function getEnrollmentDraftZipCode(
  storedDraft: EnrollmentDraftLike = getEnrollmentDraftRecord()
) {
  return withFallback(storedDraft.zipCode || readEnrollmentDraftValue('zipCode'))
}

export function getEnrollmentDraftBirthDate(fallback?: string) {
  return withFallback(
    readEnrollmentDraftValue('birthDate') || readEnrollmentDraftValue('dateOfBirth'),
    fallback
  )
}

export function getEnrollmentDraftLocationExternalId(
  storedDraft: EnrollmentDraftLike = getEnrollmentDraftRecord()
) {
  return withFallback(
    storedDraft.locationExternalId || readEnrollmentDraftValue('selected-location-external-id')
  )
}

export function getEnrollmentDraftProgramExternalId(
  storedDraft: EnrollmentDraftLike = getEnrollmentDraftRecord()
) {
  return withFallback(
    storedDraft.programExternalId || readEnrollmentDraftValue('selected-program-external-id')
  )
}

export function getEnrollmentDraftLocationState(fallback?: string) {
  return withFallback(readEnrollmentDraftValue('selected-location-state'), fallback)
}
